export const states = {
  "United States": [
    {
      title: "Alabama",
      value: "Alabama",
      id: "AL",
    },
    {
      title: "Alaska",
      value: "Alaska",
      id: "AK",
    },
    {
      title: "American Samoa",
      value: "American Samoa",
      id: "AS",
    },
    {
      title: "Arizona",
      value: "Arizona",
      id: "AZ",
    },
    {
      title: "Arkansas",
      value: "Arkansas",
      id: "AR",
    },
    {
      title: "California",
      value: "California",
      id: "CA",
    },
    {
      title: "Colorado",
      value: "Colorado",
      id: "CO",
    },
    {
      title: "Connecticut",
      value: "Connecticut",
      id: "CT",
    },
    {
      title: "Delaware",
      value: "Delaware",
      id: "DE",
    },
    {
      title: "District Of Columbia",
      value: "District Of Columbia",
      id: "DC",
    },
    {
      title: "Federated States Of Micronesia",
      value: "Federated States Of Micronesia",
      id: "FM",
    },
    {
      title: "Florida",
      value: "Florida",
      id: "FL",
    },
    {
      title: "Georgia",
      value: "Georgia",
      id: "GA",
    },
    {
      title: "Guam",
      value: "Guam",
      id: "GU",
    },
    {
      title: "Hawaii",
      value: "Hawaii",
      id: "HI",
    },
    {
      title: "Idaho",
      value: "Idaho",
      id: "ID",
    },
    {
      title: "Illinois",
      value: "Illinois",
      id: "IL",
    },
    {
      title: "Indiana",
      value: "Indiana",
      id: "IN",
    },
    {
      title: "Iowa",
      value: "Iowa",
      id: "IA",
    },
    {
      title: "Kansas",
      value: "Kansas",
      id: "KS",
    },
    {
      title: "Kentucky",
      value: "Kentucky",
      id: "KY",
    },
    {
      title: "Louisiana",
      value: "Louisiana",
      id: "LA",
    },
    {
      title: "Maine",
      value: "Maine",
      id: "ME",
    },
    {
      title: "Marshall Islands",
      value: "Marshall Islands",
      id: "MH",
    },
    {
      title: "Maryland",
      value: "Maryland",
      id: "MD",
    },
    {
      title: "Massachusetts",
      value: "Massachusetts",
      id: "MA",
    },
    {
      title: "Michigan",
      value: "Michigan",
      id: "MI",
    },
    {
      title: "Minnesota",
      value: "Minnesota",
      id: "MN",
    },
    {
      title: "Mississippi",
      value: "Mississippi",
      id: "MS",
    },
    {
      title: "Missouri",
      value: "Missouri",
      id: "MO",
    },
    {
      title: "Montana",
      value: "Montana",
      id: "MT",
    },
    {
      title: "Nebraska",
      value: "Nebraska",
      id: "NE",
    },
    {
      title: "Nevada",
      value: "Nevada",
      id: "NV",
    },
    {
      title: "New Hampshire",
      value: "New Hampshire",
      id: "NH",
    },
    {
      title: "New Jersey",
      value: "New Jersey",
      id: "NJ",
    },
    {
      title: "New Mexico",
      value: "New Mexico",
      id: "NM",
    },
    {
      title: "New York",
      value: "New York",
      id: "NY",
    },
    {
      title: "North Carolina",
      value: "North Carolina",
      id: "NC",
    },
    {
      title: "North Dakota",
      value: "North Dakota",
      id: "ND",
    },
    {
      title: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
      id: "MP",
    },
    {
      title: "Ohio",
      value: "Ohio",
      id: "OH",
    },
    {
      title: "Oklahoma",
      value: "Oklahoma",
      id: "OK",
    },
    {
      title: "Oregon",
      value: "Oregon",
      id: "OR",
    },
    {
      title: "Palau",
      value: "Palau",
      id: "PW",
    },
    {
      title: "Pennsylvania",
      value: "Pennsylvania",
      id: "PA",
    },
    {
      title: "Puerto Rico",
      value: "Puerto Rico",
      id: "PR",
    },
    {
      title: "Rhode Island",
      value: "Rhode Island",
      id: "RI",
    },
    {
      title: "South Carolina",
      value: "South Carolina",
      id: "SC",
    },
    {
      title: "South Dakota",
      value: "South Dakota",
      id: "SD",
    },
    {
      title: "Tennessee",
      value: "Tennessee",
      id: "TN",
    },
    {
      title: "Texas",
      value: "Texas",
      id: "TX",
    },
    {
      title: "Utah",
      value: "Utah",
      id: "UT",
    },
    {
      title: "Vermont",
      value: "Vermont",
      id: "VT",
    },
    {
      title: "Virgin Islands",
      value: "Virgin Islands",
      id: "VI",
    },
    {
      title: "Virginia",
      value: "Virginia",
      id: "VA",
    },
    {
      title: "Washington",
      value: "Washington",
      id: "WA",
    },
    {
      title: "West Virginia",
      value: "West Virginia",
      id: "WV",
    },
    {
      title: "Wisconsin",
      value: "Wisconsin",
      id: "WI",
    },
    {
      title: "Wyoming",
      value: "Wyoming",
      id: "WY",
    },
  ],
  Canada: [
    {
      title: "Alberta",
      value: "Alberta",
      id: "AB",
    },
    {
      title: "British Columbia",
      value: "British Columbia",
      id: "BC",
    },
    {
      title: "Manitoba",
      value: "Manitoba",
      id: "MB",
    },
    {
      title: "New Brunswick",
      value: "New Brunswick",
      id: "NB",
    },
    {
      title: "Newfoundland and Labrador",
      value: "Newfoundland and Labrador",
      id: "NL",
    },
    {
      title: "Northwest Territories",
      value: "Northwest Territories",
      id: "NT",
    },
    {
      title: "Nova Scotia",
      value: "Nova Scotia",
      id: "NS",
    },
    {
      title: "Nunavut",
      value: "Nunavut",
      id: "NU",
    },
    {
      title: "Ontario",
      value: "Ontario",
      id: "ON",
    },
    {
      title: "Prince Edward Island",
      value: "Prince Edward Island",
      id: "PE",
    },
    {
      title: "Quebec",
      value: "Quebec",
      id: "QC",
    },
    {
      title: "Saskatchewan",
      value: "Saskatchewan",
      id: "SK",
    },
    {
      title: "Yukon Territory",
      value: "Yukon Territory",
      id: "YT",
    },
  ],
};
